export default __webpack_public_path__ + "static/bgCircle-8c4864eef56f167332ee949c299955ec.png";